export default __webpack_public_path__ + "3fdee263fe69b843601fc2a6eb5baf24.woff";